import gql from 'graphql-tag';

const homeBannerQuery = gql`
  query GetHomeBanner {
    homeBanner {
      subtitle
      displayText
      bannerBackground {
        urls
      }
    }
  }
`;

export {
  homeBannerQuery,
};